import { useContext } from "react";
import { CurrentDeviceContext } from "@stadium/ui/src/contexts/responsive-content";

import DsdDetails from "@components/store/product-detail/dsd/dsd-details";
import ProductCarousel from "@components/store/product-detail/shared/product-detail-carousel";
import ProductDetailHeader from "@components/store/product-detail/shared/product-detail-header";

import useProductDetailMultipleVariantsState from "@hooks/product-detail/use-product-details-multiple-variants-state";

import { useProductInfoContext } from "@contexts/product-info-context";

import { OPTIONTYPE_PACK_KEY, PACK_OF_ONE_OPTION_TYPE_NAME } from "@constants/products/detail";

import styles from "./main.module.scss";

const Dsd = ({ product, masterVariant, canBuyProduct }) => {
  const {
    optionTypeVariantMapping,
    setOptionTypeVariantMapping,
    productQuantity,
    setProductQuantity,
    selectedImageIndex,
    setSelectedImageIndex,
    variantValues,
    getDisplayPrice,
  } = useProductDetailMultipleVariantsState({ product, masterVariant });

  const { modalClasses, hidePriceDetail } = useProductInfoContext();

  const { productImgClass = "", productContentClass = "" } = modalClasses;

  const { isMobileDevice } = useContext(CurrentDeviceContext);

  const getMeasurmentUnitInfo = () => {
    const { optionTypeKey, name, weight, measurementUnit } = optionTypeVariantMapping;
    if (optionTypeKey === OPTIONTYPE_PACK_KEY && weight && measurementUnit) {
      const weightInfo = `${weight} ${measurementUnit}`;
      return String(name) === PACK_OF_ONE_OPTION_TYPE_NAME ? weightInfo : `${name} X ${weightInfo}`;
    }
  };

  const renderProductDetailHeader = () => (
    <ProductDetailHeader
      displayPrice={!hidePriceDetail && getDisplayPrice()}
      showProductName
      product={product}
    />
  );

  const renderProductDetails = () => (
    <DsdDetails
      variantValues={variantValues}
      optionTypeVariantMapping={optionTypeVariantMapping}
      setOptionTypeVariantMapping={setOptionTypeVariantMapping}
      product={product}
      productQuantity={productQuantity}
      setProductQuantity={setProductQuantity}
      canBuyProduct={canBuyProduct}
      renderProductDetailHeader={renderProductDetailHeader}
      getMeasurmentUnitInfo={getMeasurmentUnitInfo}
    />
  );

  return (
    <div>
      <div
        data-type="product-row"
        className={`${styles.rowProductDetail} ${styles.rowWithV2Enabled}`}
      >
        {isMobileDevice && renderProductDetailHeader()}
        <div className={`${styles.productCarousalWrapper} ${productImgClass}`}>
          <ProductCarousel
            sliderImages={variantValues}
            selectedImageIndex={selectedImageIndex}
            setSelectedImageIndex={setSelectedImageIndex}
            imageMagnify
            imageCoverRequired
            carouselContainerClass={styles.withVerticalSlider}
            thumbnailContainterClass={styles.thumbBlock}
            productId={product.id}
            product={product}
          />
        </div>
        <article className={`${styles.productDetail} ${productContentClass}`}>
          <div className={styles.productDetailBox}>{renderProductDetails()}</div>
        </article>
      </div>
    </div>
  );
};

export default Dsd;
